import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { findAndUnblock } from ".";
/**
 * Use this class as main entry for your unblocking mechanism.
 *
 * **Attention:** Please make sure you start the watcher at time where the `document.readyState`
 * is not already `complete`. Why? At this time, we can make sure that our `jQuery.fn.ready` and
 * other initiators works as expected.
 */

var UnblockWatcher = /*#__PURE__*/function () {
  function UnblockWatcher(options) {
    _classCallCheck(this, UnblockWatcher);

    this.interval = void 0;
    this.options = void 0;
    this.options = options;
  }

  _createClass(UnblockWatcher, [{
    key: "unblockNow",
    value: function unblockNow() {
      return findAndUnblock(this.options);
    }
  }, {
    key: "start",
    value: function start() {
      clearInterval(this.interval);
      this.interval = setInterval(this.unblockNow.bind(this), 1000);
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this.interval);
    }
  }]);

  return UnblockWatcher;
}();

export { UnblockWatcher };